import React from 'react';
import { Mail, Calendar, MessageSquare, CheckSquare, FileText } from 'lucide-react';

const Problem = () => {
  return (
    <section id="problem" className="section-padding bg-gray-50">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
            Your calendar isn't the problem. The noise is.
          </h2>
        </div>

        {/* Problem Points */}
        <div className="max-w-4xl mx-auto space-y-8 mb-12">
          <p className="text-xl text-olive-brown/80 mb-8">Noise shows up as:</p>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4 p-6 bg-white rounded-xl card-shadow">
              <Mail className="h-6 w-6 text-burnt-orange mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-olive-brown mb-2">emails that never end</h3>
              </div>
            </div>
            
            <div className="flex items-start space-x-4 p-6 bg-white rounded-xl card-shadow">
              <Calendar className="h-6 w-6 text-burnt-orange mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-olive-brown mb-2">meetings that should've been a short message</h3>
              </div>
            </div>
            
            <div className="flex items-start space-x-4 p-6 bg-white rounded-xl card-shadow">
              <MessageSquare className="h-6 w-6 text-burnt-orange mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-olive-brown mb-2">"quick questions" that hijack your day</h3>
              </div>
            </div>
            
            <div className="flex items-start space-x-4 p-6 bg-white rounded-xl card-shadow">
              <CheckSquare className="h-6 w-6 text-burnt-orange mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-olive-brown mb-2">follow-ups you shouldn't be chasing</h3>
              </div>
            </div>
            
            <div className="flex items-start space-x-4 p-6 bg-white rounded-xl card-shadow md:col-span-2">
              <FileText className="h-6 w-6 text-burnt-orange mt-1 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-olive-brown mb-2">admin tasks that quietly pile up into stress</h3>
              </div>
            </div>
          </div>
        </div>

        {/* Closer Line */}
        <div className="text-center space-y-6">
          <p className="text-xl font-medium text-olive-brown max-w-3xl mx-auto">
            When you're the decision-maker, distractions don't just waste time—they delay outcomes.
          </p>
          
          <div className="pt-6">
            <a
              href="#contact"
              className="btn-secondary"
              aria-label="Get support for your busy week"
            >
              I need this kind of support
            </a>
            <p className="text-sm text-olive-brown/60 mt-10">If your week feels heavy, you're not alone.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;